import { render, staticRenderFns } from "./product-list-container.vue?vue&type=template&id=4da03f9c&scoped=true&lang=pug"
import script from "./product-list-container.js?vue&type=script&lang=js&external"
export * from "./product-list-container.js?vue&type=script&lang=js&external"
import style0 from "./product-list-container.vue?vue&type=style&index=0&id=4da03f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da03f9c",
  null
  
)

export default component.exports